
import React, { useState, useEffect } from "react";
import Loader from "../Components/Loader"; // Assuming correct path
import Banner from "../Components/Home/Banner/Banner";
import CollectionBox from "../Components/Home/Collection/CollectionBox";
import Services from "../Components/Home/Services/Services";
import Instagram from "../Components/Home/Instagram/Instagram";
import Trendy from "../Components/Home/Trendy/Trendy";
import LimitedEdition from "../Components/Home/Limited/LimitedEdition";
import DealTimer from "../Components/Home/Deal/DealTimer";
import HeroSection from "../Components/Home/Hero/HeroSection";
import Testimonial from "../Components/Home/Testimonial/Testimonial";

// Import Helmet
import { Helmet } from 'react-helmet-async';

const Home = () => {
  // Initialize loading state synchronously to prevent flash
  const [loading, setLoading] = useState(() => {
    return !sessionStorage.getItem('hasVisitedBefore');
  });

  useEffect(() => {
    // If not loading (return visitor), exit early
    if (!loading) return;

    // Set minimum loading time for first-time visitors
    const minLoadTime = 5000;
    const loadStartTime = Date.now();

    // Function to finish loading
    const finishLoading = () => {
      const elapsed = Date.now() - loadStartTime;
      const remainingTime = Math.max(0, minLoadTime - elapsed);

      setTimeout(() => {
        setLoading(false);
        // Mark that user has visited before
        sessionStorage.setItem('hasVisitedBefore', 'true');
      }, remainingTime);
    };

    // Use window.onload to ensure everything is loaded
    if (document.readyState === 'complete') {
      finishLoading();
    } else {
      window.addEventListener('load', finishLoading);

      // Fallback timer in case load event doesn't fire
      const fallbackTimer = setTimeout(finishLoading, minLoadTime + 2000);

      return () => {
        window.removeEventListener('load', finishLoading);
        clearTimeout(fallbackTimer);
      };
    }
  }, [loading]);

  // Show loader immediately for first-time visitors
  if (loading) return <Loader />;

  return (
    <>
      {/* Use Helmet to manage head tags for the Home page */}
      <Helmet>
        <title>Zircon Jewels Pakistan: Handcrafted Jewellery in Karachi</title>
        <meta
          name="description"
          content="Discover exquisite handcrafted Pakistani jewelry from our base in Karachi. Shop gold, diamond, and zircon rings, bridal sets, and more. Free shipping & COD available."
        />
        <meta
          name="keywords"
          content="Pakistani jewelry, gold jewelry Pakistan, online jewelry shopping Karachi, bridal jewelry, Eid collection, rings, earrings, Zircon Jewels"
        />
        <link rel="canonical" href="https://zircon-jewels.zircon-jewels.pages.dev/" />

        {/* --- FIXED URLS BELOW --- */}
        <meta property="og:title" content="Zircon Jewels Pakistan: Handcrafted Jewellery" />
        <meta property="og:description" content="Beautiful handcrafted jewellery with free nationwide delivery from our Karachi store." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://zircon-jewels.zircon-jewels.pages.dev/" />
        <meta property="og:image" content="https://zircon-jewels.zircon-jewels.pages.dev/og-image.jpg" />
        <meta property="og:site_name" content="Zircon Jewels Pakistan" />
      </Helmet>

      {/* Your existing Home page components */}
      <HeroSection />
      <CollectionBox /> 
      <Trendy />
      <DealTimer />
      <Banner />
      <LimitedEdition />
      <Instagram />
      <Testimonial />
      <Services />
    </>
  );
};

export default Home;
// --- END OF MODIFIED FILE src/Pages/Home.jsx ---